import { z } from 'zod';
import { CardEnum } from '../CardState.ts';
import { createKeyRecordSchema, createTradeIdKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { PlayerColor } from '../PlayerState.ts';
import { validateState } from '../ValidateState.ts';
import { tradeIdSchema } from './TradeId.ts';
import { EnumUtils } from '@colonist/utils';
export var TradeResponseStatus = /*#__PURE__*/ function(TradeResponseStatus) {
    TradeResponseStatus[TradeResponseStatus["PendingResponse"] = 0] = "PendingResponse";
    TradeResponseStatus[TradeResponseStatus["Accepted"] = 1] = "Accepted";
    TradeResponseStatus[TradeResponseStatus["Rejected"] = 2] = "Rejected";
    TradeResponseStatus[TradeResponseStatus["Embargoed"] = 3] = "Embargoed";
    return TradeResponseStatus;
}({});
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
export const tradeOfferStateObjectSchema = z.object({
    id: tradeIdSchema.readonly(),
    creator: z.enum(PlayerColor).readonly(),
    offeredResources: z.array(z.enum(CardEnum)).readonly(),
    wantedResources: z.array(z.enum(CardEnum)).readonly(),
    counterOfferInResponseToTradeId: tradeIdSchema.nullable().optional().readonly(),
    playersCreatingCounterOffer: createKeyRecordSchema(playerColorNumericKeys, z.boolean()).readonly(),
    playerResponses: createKeyRecordSchema(playerColorNumericKeys, z.enum(TradeResponseStatus)).readonly(),
    forcedResponse: z.enum(TradeResponseStatus).readonly().exactOptional()
}).strict();
export const tradeOfferStateSchema = tradeOfferStateObjectSchema;
export function validateTradeOfferState(data) {
    return validateState(tradeOfferStateSchema, data);
}
export const tradeActiveOffersSchema = createTradeIdKeyRecordSchema(tradeOfferStateSchema);
export function validateTradeActiveOffers(data) {
    return validateState(tradeActiveOffersSchema, data);
}
export const tradeOfferStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(tradeOfferStateObjectSchema);
const tradeActiveOfferPartialValueSchema = z.union([
    tradeOfferStatePartialSchema,
    z.null()
]);
export const tradeActiveOffersPartialSchema = createTradeIdKeyRecordSchema(tradeActiveOfferPartialValueSchema, {
    requireAtLeastOneEntry: true
});
export function validateTradeActiveOffersPartial(data) {
    return validateState(tradeActiveOffersPartialSchema, data);
}
export function isFullTradeState(tradeState) {
    return validateTradeOfferState(tradeState).success;
}
